import CollectGraphicsBlockSelectField from "./collect-graphics-block-select-field";

const CollectGraphicsFields = {
    BlockSelect: CollectGraphicsBlockSelectField
};

export default CollectGraphicsFields;
